import React from 'react';
import './CenteredBannerLayout.css';
import { useSelector } from 'react-redux';
import { BannerTerms } from '../BannerTerms';
import { OffersDataService } from '../../../../services/offers-data.service';
import { BannerCtaContainer } from '../BannerCtaContainer';

export const CenteredBannerLayout = ({ isLanding, isPayNPlayEnabled, bannerAction }) => {
    const {
        description,
        image,
        mobileImage,
        mainBannerLayout
    } =  OffersDataService.getOffersData();
    const { isMobile } = useSelector(state => state.app);

    return (<div className="centered-banner-container">
        <img src={isMobile ? mobileImage : image} alt="Banner" className="centered-banner-image" loading="lazy" />
        <div className="centered-banner-wrapper">
            <p
                className={`centered-banner-title ${mainBannerLayout}`}
                dangerouslySetInnerHTML={{ __html: description }}
            ></p>

            <BannerCtaContainer
                ctaClassName="centered-banner-cta"
                isLanding={isLanding}
                isPayNPlayEnabled={isPayNPlayEnabled}
                bannerAction={bannerAction}
            />

            <BannerTerms className="centered-banner-terms" />
        </div>
    </div>);
};
